




















































import BaseComponent from "@/asdcom/BaseComponent";
import { Prop, Component, Watch } from "vue-property-decorator";
import { AttachmentDto } from "@/asdcom/apiproxy/apiproxy.dto";
import AttachmentsComponent from "@/components/vcponlineok/attachments/attachments-component.vue";
import { Location } from "vue-router";
import ClaimSummarySectionItem from "@/components/vcponlineok/claim-summary/claim-summary-section-item.vue";

export interface IClaimSummaryLabelValue {
  label?: string;
  value?: any;
  valueList?: string[];
  // component?: any;
  html?: string;
}
export interface IClaimSummarySectionItem {
  headerHtml?: string;
  oneColTop?: Array<IClaimSummaryLabelValue>;
  leftCol?: Array<IClaimSummaryLabelValue>;
  rightCol?: Array<IClaimSummaryLabelValue>;
  oneColBottom?: Array<IClaimSummaryLabelValue>;
}

export interface IClaimSummarySectionData {
  topCenter: Array<IClaimSummaryLabelValue>;
  itemList: Array<IClaimSummarySectionItem>;
  attachments?: Array<AttachmentDto>;
}

@Component({
  components: {
    AttachmentsComponent,
    ClaimSummarySectionItem
  }
})
export default class ClaimSummarySectionComponent extends BaseComponent {
  // @Prop({ default: () => false })

  @Prop({
    default: () => {
      return null;
    }
  })
  sectionData: IClaimSummarySectionData;

  @Prop({ default: "[sectionTitle not spefified]" })
  sectionTitle: string;

  get isDataEmpty() {
    let ret =
      this.sectionData == undefined ||
      this.sectionData.itemList == undefined ||
      (this.sectionData.itemList !== undefined &&
        this.sectionData.itemList.length == 0 &&
        this.sectionData.topCenter.length == 0);
    return ret;
  }

  get dataItems(): Array<IClaimSummarySectionItem> {
    //abp.log.debug({ "dataItems attach": this.sectionData.attachments });
    return this.sectionData.itemList || [];
  }
  get attachments(): AttachmentDto[] | undefined {
    if (this.sectionData == undefined) {
      return undefined;
    } else {
      return this.sectionData.attachments;
    }
  }
  get topCenter(): Array<IClaimSummaryLabelValue> {
    return this.sectionData.topCenter || [];
  }
}
